import React from 'react'

import mobileMap from './assets/footprints/mobile-map.webp'
import desktopMap from './assets/footprints/desktop-map.webp'
import mobileBloom from './assets/footprints/mobile-bloom.webp'
import desktopBloom from './assets/footprints/desktop-bloom.webp'

// Fixed snapshots of the real map. The homepage never loads the map runtime/data.
export default function MapPreview() {
  return (
    <>
      <picture>
        <source media="(max-width: 640px)" srcSet={mobileMap} />
        <img
          className="FootprintsMapImage"
          src={desktopMap}
          width="1146"
          height="988"
          alt=""
          loading="lazy"
          decoding="async"
        />
      </picture>
      <picture>
        <source media="(max-width: 640px)" srcSet={mobileBloom} />
        <img
          className="FootprintsMapImage FootprintsOsmanthusBloom"
          src={desktopBloom}
          width="1146"
          height="988"
          alt=""
          loading="lazy"
          decoding="async"
        />
      </picture>
    </>
  )
}
